import { render, staticRenderFns } from "./ReportDesktopMoreMeals.vue?vue&type=template&id=4989ca58"
import script from "./ReportDesktopMoreMeals.vue?vue&type=script&lang=js"
export * from "./ReportDesktopMoreMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports